import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";

// const defaultUserId = process.env.NODE_ENV === "development" ? 1 : null;

const defaultUserId = null;
const state = {
  token: getToken(),
  truename: "",
  headImagePath: "",
  notifyUrl: null,
  roles: [],
  userId: defaultUserId,
  vipType: false,
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NOTIFY_URL: (state, notifyUrl) => {
    state.notifyUrl = notifyUrl;
  },
  SET_USER_ID: (state, id) => {
    state.userId = id;
  },
  SET_TRUE_NAME: (state, truename) => {
    state.truename = truename;
  },
  SET_HEAD_IMAGE_PATH: (state, headImagePath) => {
    state.headImagePath = headImagePath;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_VIP_TYPE: (state, vipType) => {
    state.vipType = vipType;
  },
};

const actions = {
  // user login
  login({ commit }, loginForm) {
    const { username, password, phone } = loginForm;
    return new Promise((resolve, reject) => {
      this._vm.axios
        .post("/view/member/login", {
          username,
          password,
          phone,
        })
        .then((data) => {
          commit("SET_TOKEN", data);
          // setToken(data)
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  async getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.axios
        .get("/api/v1/me", { headers: { "X-DQ123-Authorization": "Bearer " + state.token } })
        .then((data) => {
          if (!data || !data.userId || data.groupid === 2) {
            commit("SET_USER_ID", null);
            commit("SET_TRUE_NAME", null);
            commit("SET_HEAD_IMAGE_PATH", null);
            commit("SET_TOKEN", null);
            commit("SET_NOTIFY_URL", null);
            commit("SET_VIP_TYPE", false);
            removeToken();
            router.push("/");
            resolve(data);
          } else {
            commit("SET_USER_ID", data.userId);
            commit("SET_TRUE_NAME", data.truename);
            commit("SET_HEAD_IMAGE_PATH", data.headImagePath);
            commit("SET_NOTIFY_URL", data.notifyUrl);
            data.vipType = false;
            if (data.memberType && data.memberType !== 0) {
              data.vipType = true;
            }
            commit("SET_VIP_TYPE", data.vipType);
            resolve(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  async logout({ commit, state, dispatch }) {
    await this._vm.axios.get("/api/v1/view/member/logout");
    commit("SET_USER_ID", null);
    commit("SET_TRUE_NAME", null);
    commit("SET_HEAD_IMAGE_PATH", null);
    commit("SET_TOKEN", null);
    // removeToken()
    resetRouter();
    router.push("/");
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
